import { Component, Input } from '@angular/core';
import { DisclaimerTypes } from '../../interfaces/disclaimertypes';
import { appurl, LEGAL_AVV, LEGAL_IMPRINT, LEGAL_PRIVACY_POLICY, LEGAL_TERMS_OF_CONDITIONS, LEGAL_TERMS_OF_USE, LEGAL_TOMS } from '../../../environments/environment';

@Component({
    selector: 'rr-disclaimer',
    standalone: false,
    templateUrl: './disclaimer.component.html',
    styleUrl: './disclaimer.component.scss'
})
export class DisclaimerComponent {
    @Input({ required: true }) type: DisclaimerTypes = DisclaimerTypes.DEFAULT;
    @Input() showIcon: boolean = true;
    appUrl = appurl;

    public legalAvv = LEGAL_AVV;
    public legalToms = LEGAL_TOMS;
    public legalToCs = LEGAL_TERMS_OF_CONDITIONS;
    public legalToU = LEGAL_TERMS_OF_USE;
    public legalPrivacyPolicy = LEGAL_PRIVACY_POLICY;
    public legalImprint = LEGAL_IMPRINT;

}
